"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReinstateErrorCodeInputSchema = exports.RetireErrorCodeInputSchema = exports.UpdateErrorCodeInputSchema = exports.CreateErrorCodeInputSchema = exports.ListErrorCodesInputSchema = void 0;
const z = require("zod");
const property_key_1 = require("../Consensus/property-key");
const spec_handle_1 = require("./spec-handle");
exports.ListErrorCodesInputSchema = z.object({
    propertyKeys: z
        .array(property_key_1.PropertyKeySchema)
        .optional()
        .describe('Package-data properties to restrict the codes to. Omit to read every property.'),
    includeRetired: z.boolean().optional().describe('Include codes that have been retired. Defaults to false.'),
});
exports.CreateErrorCodeInputSchema = z.object({
    propertyKey: property_key_1.PropertyKeySchema,
    code: spec_handle_1.SpecHandleSchema,
    description: z.string().min(1),
});
exports.UpdateErrorCodeInputSchema = z.object({
    errorCodeId: z.string(),
    code: spec_handle_1.SpecHandleSchema.optional(),
    description: z.string().min(1).optional(),
});
exports.RetireErrorCodeInputSchema = z.object({
    errorCodeId: z.string(),
    retirementComment: z.string().optional(),
});
exports.ReinstateErrorCodeInputSchema = z.object({
    errorCodeId: z.string(),
});
//# sourceMappingURL=package-inference-error-code.inputs.js.map